import React, { useState, useEffect, useRef } from "react";

import { header, host } from "../globalVariables";
import Button from "react-bootstrap/Button";
// import rocketVid from "./img/rocketlaunch.mp4";
// import trippyVid from "./img/trippy.mp4";
// import starVid from "./img/star.mp4";
import starsVid from "../img/stars.mp4";
import fireworksVid from "../img/fireworks.mp4";

import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from "@azure/msal-react";
import CurrencyInput from "react-currency-input-field";
import { api, getStaticData, httpPost } from "../pureFunctions";
import { useConfig } from "../ConfigContext";
import { useM365Context } from "../m365Context";

const buzzerPriceField = "ind_3540_Feld_ObjIndividualCategoryFields350";

export default function Buzzer({ handleRedirect, handleLogoutRedirect, activeAccount }) {
   const { postMsTeamsTeamMessage } = useM365Context();

   const config = useConfig();
   const [estateId, setEstateId] = useState(false);
   const [estateData, setEstateData] = useState();
   const [playVideo, setPlayVideo] = useState();
   const [userObjects, setUserObjects] = useState();
   const [loading, setLoading] = useState();

   const [price, setPrice] = useState("");

   async function sendData() {
      //buzzer: ind_3290_Feld_ObjIndividualCategoryFields288
      setLoading("loading");

      await httpPost(
         host + "/api/updateSpecificEstateField",
         {
            estateId: estateId,
            oOdata: { [buzzerPriceField]: price },
         },
         () => {},
         () => {},
      );
   }

   async function getData(url_id) {
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();

      console.log(cleanUserData);

      setUserObjects(cleanUserData.userObject);

      const responseData = await api
         .post(
            "/api/getEstateBasicData",
            [
               {
                  id: url_id,
                  datarequest: [
                     "objektnr_extern",
                     "benutzer",
                     config.estate.objektBezeichnung,
                     config.estate.verkauftFur,
                     "kaufpreis",
                  ],
               },
            ],
            header,
         )
         .then((data) => {
            console.log(data);

            setEstateData(data.data);
            setPrice(
               parseFloat(data?.data?.[config.estate.verkauftFur] ?? 0) || parseFloat(data?.data?.kaufpreis ?? 0),
            );
         })
         .catch((err) => {
            console.log(JSON.stringify(err.response.data, null, 1));
            setErrorMessage(JSON.stringify(err.response.data, null, 1));
         });
   }
   //teams.microsoft.com/l/channel/19%3A707394de6d554834a06ced1484092774%40thread.tacv2/Fun%20Kanal?groupId=a597b6ed-144a-496d-9e1f-dee799af880e&tenantId=f6e03af0-f62c-4ef2-a542-c02a29109b93
   function sendBuzzer() {
      setPlayVideo(true);
      const teamId = import.meta.env.PROD
         ? "a597b6ed-144a-496d-9e1f-dee799af880e"
         : "5f9e0c1e-8a83-4cd1-a2d7-51dfc4825f87";

      const channelId = import.meta.env.PROD
         ? "19%3A707394de6d554834a06ced1484092774%40thread.tacv2" //fun-kanal
         : "19%3Abcef8ed598784d59a10ca7fa950d2c86%40thread.tacv2";

      let link =
         "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExcDZxcXI4dnBqaHc2YjR6aDN4bjk1bnV5dnB5dGhoYm5nOHlza3dmaCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/HzPtbOKyBoBFsK4hyc/giphy.gif";
      // link=""
      const jackpotlink =
         "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExa3Z0ZmRoeWVjenY1cHMyazIyZGk2NGQzeDlwcm9ldTJzanJybmtzMCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/917Ve5cLpoB3Nhd1xh/giphy.gif";
      const celebratelink =
         "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExbW5icWdneXozMGszZThhdWxhdndiZjA3Y3A3YXVvcWlmdzB6ZmdsdCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Is1O1TWV0LEJi/giphy.gif";
      const partylink =
         "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExa2ZzOW9qcG10MHVheGFvMmNoMDdvcXF0eWlveWFqdzBwcGVzN21uOCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/xT1Ra72UKP2s03l69O/giphy.gif";
      //const link="https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExbWlpbG9mMnFkYmE2bjZoemFmYWdjN2Z5N3k5eWwxN290a2M5Nml3NCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/xThuWu82QD3pj4wvEQ/giphy.gif"

      let orderData = {
         body: {
            contentType: "html",
            content: `
                <div>
                  <h1>🎉Neuer Kaufvertrag abgeschlossen🎉</h1>
                  <div style="display: flex; flex-direction: column; flex-wrap: nowrap;"> 
                    <div style="display: inline-block;">
                    ${userObjects?.[estateData.benutzer]?.Vorname ?? "Jemand"} ${userObjects?.[estateData.benutzer]?.Nachname ?? ""} hat einen Kaufvertrag in der Höhe von <strong>${new Intl.NumberFormat(
                       "de-DE",
                       { style: "currency", currency: "EUR" },
                    ).format(
                       price,
                    )}</strong> für das Objekt <strong>${estateData[config.estate.objektBezeichnung]}</strong> abgeschlossen.
                  </div>
              <img style="display: inline-block;" height="100" src="${link}" width="100">
            </div>
        </table>
    </div>`,
         },
      };
      postMsTeamsTeamMessage(teamId, channelId, orderData);
      sendData();
   }

   useEffect(() => {
      let params = new URLSearchParams(document.location.search);
      const url_id = params.get("estateid");
      setEstateId(url_id);
      console.log(url_id);
      if (url_id) {
         getData(url_id);
      }
   }, []);

   return (
      <div
         className="text-center p-5"
         style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 10000,
            backgroundColor: "#111",
            height: "100dvh",
            width: "100dvw",
         }}
      >
         <AuthenticatedTemplate>
            {activeAccount ? (
               <>
                  {estateData && (
                     <>
                        {playVideo ? (
                           <video className="buzzer-video" autoPlay loop muted key={fireworksVid} id="myVideo2">
                              <source src={fireworksVid} type="video/mp4" />
                           </video>
                        ) : (
                           <video className="buzzer-video" autoPlay loop muted key={starsVid} id="myVideo">
                              <source src={starsVid} type="video/mp4" />
                           </video>
                        )}

                        <div className="buzzer">
                           <h1>Buzzer</h1>
                           <textarea
                              onChange={(e) => {
                                 setEstateData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                              }}
                              spellCheck={false}
                              style={{
                                 textAlign: "center",
                                 borderRadius: 16,
                                 border: "solid 4px #fff1",
                                 textShadow: "0 0 6px #000",
                                 background: "#1115",
                                 whiteSpace: "pre-line",
                                 textWrap: "wrap",
                                 // wordBreak: "break-all",
                                 minHeight: "80px",
                                 fieldSizing: "content",
                              }}
                              name={config.estate.objektBezeichnung}
                              value={estateData[config.estate.objektBezeichnung]}
                           />
                           {/* {estateData.url && (
                    <div className="buzzer-image"><img
                    
                      src={estateData.url}
                    /></div>
                  )} */}
                           <CurrencyInput
                              placeholder="---"
                              allowNegativeValue={false}
                              decimalsLimit={2}
                              suffix="€"
                              decimalSeparator=","
                              groupSeparator="."
                              className="buzzer-input"
                              style={{ fontSize: playVideo ? "xx-large" : "large" }}
                              type="text"
                              value={price}
                              onChange={(e) => setPrice(e.target.value)}
                           />
                           <button
                              style={{ opacity: playVideo ? 0 : 1 }}
                              className="buzzer-button"
                              onClick={() => sendBuzzer()}
                           >
                              Absenden
                           </button>
                        </div>
                     </>
                  )}
                  <Button
                     variant="outline-secondary"
                     style={{ position: "absolute", top: "10px", left: "10px" }}
                     onClick={handleLogoutRedirect}
                  >
                     ←
                  </Button>
               </>
            ) : null}
         </AuthenticatedTemplate>
         <UnauthenticatedTemplate>
            <div className="m-5">
               <Button className="p-5 w-100" onClick={handleRedirect} variant="primary">
                  Login mit Teamsaccount (Microsoft)
               </Button>
            </div>
         </UnauthenticatedTemplate>
      </div>
   );
}
